import { Component, inject, Signal, type WritableSignal } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { type SafeHtml } from '@angular/platform-browser';
import { Translate } from '@services/core/translate';
import { Button } from '@shared/button/button';
import type { CssColor, IconName } from '@appTypes';

export type AlertDialogInteraction = 'none' | 'accept' | 'cancel_accept';

export type AlertButtonConfig = {
  text?: string;
  icon?: IconName;
  textColor?: CssColor;
  iconColor?: CssColor;
};

export type AlertDialogInput = {
  $icon: WritableSignal<SafeHtml>,
  $title: Signal<string | null>,
  $message: Signal<string | null>,
  $interaction: WritableSignal<AlertDialogInteraction>,
  $cancelButton?: WritableSignal<AlertButtonConfig | null>,
  $acceptButton?: WritableSignal<AlertButtonConfig | null>,
};

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [ Button ],
  templateUrl: './alert-container.html',
})
export class AlertContainer {
  // Dependencias
  public readonly t = inject(Translate).translateFn();
  private readonly dialogRef = inject(DialogRef);
  readonly inputData = inject<AlertDialogInput>(DIALOG_DATA);

  // Cierra el diálogo con la opción de cierre indicada
  close(option: boolean) {
    this.dialogRef.close(option);
  }
}
